import { graphql } from 'gatsby'
import React from 'react'
import IconCardGrid, {
  IconCardGridContent,
} from 'src/components/organisms/general/iconCardGrid'

// TEMP: Use any until Prismic schema is added and `npm run type-graphql` is run.
// type Props = { slice: PrismicPageDataBodyIconCardGrid }
type Props = { slice: any }

const IconCardGridSlice = ({ slice }: Props) => {
  const primary = slice?.primary ?? {}
  const items = slice?.items ?? []

  const content: IconCardGridContent = {
    anchor: primary.anchor ?? undefined,
    headline: primary.headline ?? undefined,
    cards: items.map((item: any) => ({
      iconUrl: item?.icon?.url ?? undefined,
      iconAlt: item?.icon?.alt ?? undefined,
      title: item?.title ?? undefined,
      description: item?.cardDescription ?? undefined,
    })),
  }

  return <IconCardGrid content={content} />
}

export default IconCardGridSlice

export const fragmentQuery = graphql`
  fragment PageDataBodyIconCardGrid on PrismicPageDataBodyIconCardGrid {
    primary {
      anchor
      headline
    }
    items {
      icon {
        url
        alt
      }
      title
      cardDescription: description
    }
  }
`
